import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

// Layout components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Public Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Programs from "./pages/Programs";
import Health from "./pages/Health";
import Environment from "./pages/Environment";
import Gallery from "./pages/Gallery";
import Reports from "./pages/Reports";
import Members from "./pages/Members";
import Contact from "./pages/Contact";

// ================= ADMIN IMPORTS =================
import AdminLayout from "./admin/layout/AdminLayout";
import AdminLogin from "./admin/auth/AdminLogin";
import ProtectedRoute from "./admin/auth/ProtectedRoute";
import Dashboard from "./admin/pages/Dashboard";
import ProgramList from "./admin/pages/programs/ProgramList";

// Global CSS
import "./styles/global.css";


// ================= NAVBAR HELPER =================
const NavbarWithActivePage = () => {
  const location = useLocation();

  // Hide Navbar on admin pages
  if (location.pathname.startsWith("/admin")) {
    return null;
  }

  const pathToName = {
    "/": "Home",
    "/about": "About",
    "/programs": "Programs",
    "/health": "Health",
    "/environment": "Environment",
    "/gallery": "Gallery",
    "/reports": "Reports",
    "/members": "Members",
    "/contact": "Contact",
  };

  const activePage = pathToName[location.pathname] || "";

  return <Navbar activePage={activePage} />;
};


// ================= FOOTER HELPER =================
const FooterWrapper = () => {
  const location = useLocation();

  // Hide Footer on admin pages
  if (location.pathname.startsWith("/admin")) {
    return null;
  }

  return <Footer />;
};


// ================= MAIN APP =================
function App() {
  return (
    <Router>
      <NavbarWithActivePage />

      <main className="app">
        <div className="section-wrapper">
          <Routes>

            {/* ================= PUBLIC ROUTES ================= */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/health" element={<Health />} />
            <Route path="/environment" element={<Environment />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/members" element={<Members />} />
            <Route path="/contact" element={<Contact />} />

            {/* ================= ADMIN LOGIN ================= */}
            <Route path="/admin-login" element={<AdminLogin />} />

            {/* ================= ADMIN PROTECTED ROUTES ================= */}
            <Route
              path="/admin/*"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              {/* /admin → Dashboard */}
              <Route index element={<Dashboard />} />

              {/* /admin/programs */}
              <Route path="programs" element={<ProgramList />} />

            </Route>

          </Routes>
        </div>
      </main>

      <FooterWrapper />
    </Router>
  );
}

export default App;